import { FC } from 'react';

import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

import { AngleForward, Check } from '@assets/icons';

export interface WorkspaceOptionItemProps {
  option: any;
  isSelected?: boolean;
  onNextClick?(e: any): void;
  classOverride?: string;
  isLogin?: boolean;
}

const CLIENT_ID_WITHOUT_PARENT = 0;

const WorkspaceOptionItem: FC<WorkspaceOptionItemProps> = ({
  option,
  isSelected = false,
  onNextClick = () => null,
  classOverride = '',
  isLogin = false,
}) => {
  const isNoParentClientOption = option.clientId === CLIENT_ID_WITHOUT_PARENT;

  return (
    <span
      className={twMerge(
        classNames(
          'flex items-center justify-between cursor-pointer focus:select-none pl-4 h-[45px] border-b border-gray-2 pr-2',
          isLogin ? 'hover:bg-blue-6' : 'hover:bg-lightest',
        ),
      )}
    >
      <span
        className={twMerge('text-sm block truncate flex-grow', classOverride)}
      >
        {option.name}
      </span>
      <div className="flex items-center">
        <Check
          className={twMerge(
            classNames(
              'flex-none',
              isLogin ? 'text-blue-5' : 'text-primary',
              !isSelected ? 'invisible' : '',
              isNoParentClientOption ? 'mx-3' : 'mx-2',
            ),
          )}
        />
        {!isNoParentClientOption && (
          <div
            className={twMerge(
              classNames(
                'text-white rounded-md cursor-pointer p-1',
                isLogin ? 'bg-blue-5' : 'bg-primary',
              ),
            )}
            onClick={e => onNextClick(e)}
          >
            <AngleForward className="h-3 w-3" />
          </div>
        )}
      </div>
    </span>
  );
};

export default WorkspaceOptionItem;
